module.exports = __webpack_public_path__ + "img/page_desarrolla_slider2.5f143011.png";